<template>
  <div class="px-10 py-5">
    <div class="text-h6 mb-3 accent--text">
      Product category<span v-if="rules.category"> *</span>
    </div>
    <v-badge
      v-if="differences.category"
      color="pink"
      icon="mdi-pencil"
      class="d-flex justify-end"
    ></v-badge>
    <v-select
      :rules="rules.category ? rules.category : []"
      v-if="isForm"
      :disabled="readOnly"
      clearable
      placeholder="Choose a category"
      dense
      v-model="attributesValue.data.category"
      :items="selectItems.categories"
      outlined
    ></v-select>
    <div v-else class="pt-0 pb-3">{{ attributesValue.data.category }}</div>
    <div class="text-h6 mb-3 accent--text">
      Target gender <span v-if="rules.gender"> *</span>
    </div>
    <v-badge
      v-if="differences.gender"
      color="pink"
      icon="mdi-pencil"
      class="d-flex justify-end"
    ></v-badge>
    <v-select
      :rules="rules.gender ? rules.gender : []"
      v-if="isForm"
      :disabled="readOnly"
      v-model="attributesValue.data.gender"
      placeholder="Choose a gender"
      clearable
      dense
      :items="selectItems.genders"
      outlined
    ></v-select>
    <div v-else class="pt-0 pb-3">{{ attributesValue.data.gender }}</div>
    <div class="text-h6 mb-3 accent--text">
      Product type <span v-if="rules.product_type"> *</span>
    </div>
    <v-badge
      v-if="differences.product_type"
      color="pink"
      icon="mdi-pencil"
      class="d-flex justify-end"
    ></v-badge>
    <v-select
      :rules="rules.product_type ? rules.product_type : []"
      v-if="isForm"
      :disabled="readOnly"
      clearable
      placeholder="Choose a type"
      dense
      v-model="attributesValue.data.product_type"
      :items="selectItems.product_types"
      outlined
    ></v-select>
    <div v-else class="pt-0 pb-3">{{ attributesValue.data.product_type }}</div>

    <!-- Start Year/Month/Date of launch -->
    <div class="text-h6 mb-3 accent--text">
      Year of launch <span v-if="rules.year"> *</span>
    </div>
    <v-badge
      v-if="differences.year"
      color="pink"
      icon="mdi-pencil"
      class="d-flex justify-end"
    ></v-badge>
    <v-text-field
      type="number"
      :rules="rules.year ? rules.year : []"
      v-if="isForm"
      :disabled="readOnly"
      clearable
      dense
      min="1"
      @change="
        attributesValue.data.year =
          attributesValue.data.year <= 999
            ? 1000
            : attributesValue.data.year > new Date().getFullYear()
            ? new Date().getFullYear()
            : attributesValue.data.year
      "
      v-model="attributesValue.data.year"
      outlined
    ></v-text-field>
    <div v-else class="pt-0 pb-3">{{ attributesValue.data.year }}</div>
    <div class="text-h6 mb-3 accent--text">
      Month of launch <span v-if="rules.month"> *</span>
    </div>
    <v-text-field
      type="number"
      :rules="rules.month ? rules.month : []"
      v-if="isForm"
      :disabled="readOnly"
      clearable
      max="12"
      min="1"
      @change="
        attributesValue.data.month =
          attributesValue.data.month > 12
            ? 12
            : attributesValue.data.month <= 0
            ? 1
            : attributesValue.data.month
      "
      dense
      v-model="attributesValue.data.month"
      outlined
    ></v-text-field>
    <div v-else class="pt-0 pb-3">{{ attributesValue.data.month }}</div>

    <div class="text-h6 mb-3 accent--text">
      Date of launch <span v-if="rules.launched_at"> *</span>
    </div>
    <v-badge
      v-if="differences.launched_at"
      color="pink"
      icon="mdi-pencil"
      class="d-flex justify-end"
    ></v-badge>
    <v-menu
      v-model="menu1"
      v-if="isForm"
      ref="menu1"
      :close-on-content-click="false"
      :return-value.sync="attributesValue.data.launched_at"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          :rules="rules.launched_at ? rules.launched_at : []"
          :disabled="readOnly"
          dense
          clearable
          outlined
          v-model="attributesValue.data.launched_at"
          placeholder="Pick a date"
          prepend-inner-icon="mdi-calendar"
          readonly
          v-bind="attrs"
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="attributesValue.data.launched_at"
        no-title
        scrollable
        :close-on-content-click="true"
        @input="updateYearAndMonthFromDate"
      >
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="menu1 = false">
          Cancel
        </v-btn>
        <v-btn
          text
          color="primary"
          @click="$refs.menu1.save(attributesValue.data.launched_at)"
        >
          OK
        </v-btn>
      </v-date-picker>
    </v-menu>
    <div v-else class="pt-0 pb-3">{{ attributesValue.data.launched_at }}</div>

    <hr class="mb-5 mt-2 border-none border-slate-800 border-b" />

    <!-- Start Product price and discontinuation -->
    <div class="text-h6 mb-3 accent--text">
      Price (indicative for 100ml) <span v-if="rules.price"> *</span>
    </div>
    <v-badge
      v-if="differences.price"
      color="pink"
      icon="mdi-pencil"
      class="d-flex justify-end"
    ></v-badge>
    <v-text-field
      type="number"
      :rules="rules.price ? rules.price : []"
      v-if="isForm"
      :disabled="readOnly"
      clearable
      dense
      v-model="attributesValue.data.price"
      outlined
      prepend-inner-icon="mdi-currency-eur"
      @change="
        attributesValue.data.price =
          attributesValue.data.price && attributesValue.data.price <= 0
            ? 1
            : attributesValue.data.price
      "
    ></v-text-field>
    <div v-else class="pt-0 pb-3">{{ attributesValue.data.product_type }}</div>
    <div class="text-h6 mb-3 accent--text">
      Is product discontinued? <span v-if="rules.discontinued"> *</span>
    </div>
    <v-badge
      v-if="differences.discontinued"
      color="pink"
      icon="mdi-pencil"
      class="d-flex justify-end"
    ></v-badge>
    <v-select
      :rules="rules.discontinued ? rules.discontinued : []"
      v-if="isForm"
      :disabled="readOnly"
      clearable
      v-model="attributesValue.data.discontinued"
      placeholder="Choose 'Yes' or 'No'"
      dense
      item-text="label"
      item-value="value"
      :items="[
        { value: 1, label: 'Yes' },
        { value: 0, label: 'No' }
      ]"
      outlined
    ></v-select>
    <div v-else class="pt-0 pb-3">{{ attributesValue.data.discontinued }}</div>
    <div class="text-h6 mb-3 accent--text">
      Date of discontinuation <span v-if="rules.discontinued_at"> *</span>
    </div>
    <v-badge
      v-if="differences.discontinued_at"
      color="pink"
      icon="mdi-pencil"
      class="d-flex justify-end"
    ></v-badge>
    <v-menu
      v-model="menu2"
      v-if="isForm"
      ref="menu"
      :close-on-content-click="false"
      :return-value.sync="attributesValue.data.discontinued_at"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          :rules="rules.discontinued_at ? rules.discontinued_at : []"
          :disabled="readOnly"
          dense
          clearable
          outlined
          v-model="attributesValue.data.discontinued_at"
          placeholder="Pick a date"
          prepend-inner-icon="mdi-calendar"
          readonly
          v-bind="attrs"
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="attributesValue.data.discontinued_at"
        no-title
        scrollable
      >
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="menu2 = false">
          Cancel
        </v-btn>
        <v-btn
          text
          color="primary"
          @click="$refs.menu.save(attributesValue.data.discontinued_at)"
        >
          OK
        </v-btn>
      </v-date-picker>
    </v-menu>
    <div v-else class="pt-0 pb-3">
      {{ attributesValue.data.discontinued_at }}
    </div>

    <hr class="mb-5 mt-2 border-none border-slate-800 border-b" />

    <!-- Start olfactive notes -->
    <div class="text-h6 mb-3 accent--text">
      Olfactive universe
    </div>
    <v-badge
      v-if="
        differences.product_families && differences.product_families.families
      "
      color="pink"
      icon="mdi-pencil"
      class="d-flex justify-end"
    ></v-badge>
    <v-autocomplete
      :rules="
        rules.product_families && rules.product_families.families
          ? rules.product_families.families
          : []
      "
      :disabled="readOnly"
      multiple
      return-object
      chips
      deletable-chips
      :label="
        'Families' +
          (rules.product_families && rules.product_families.families
            ? ' *'
            : '')
      "
      clearable
      :items="selectItems.product_families"
      :loading="loading.product_families"
      v-model="attributesValue.data.product_families.families"
      item-text="family.name"
      item-value="family.id"
      outlined
      :search-input.sync="searchInput"
      @change="searchInput = ''"
    ></v-autocomplete>
    <v-badge
      v-if="
        differences.product_families &&
          differences.product_families.sub_families
      "
      color="pink"
      icon="mdi-pencil"
      class="d-flex justify-end"
    ></v-badge>
    <v-autocomplete
      :rules="
        rules.product_families && rules.product_families.sub_families
          ? rules.product_families.sub_families
          : []
      "
      :disabled="readOnly"
      multiple
      return-object
      chips
      deletable-chips
      :label="
        'Sub families' +
          (rules.product_families && rules.product_families.sub_families
            ? ' *'
            : '')
      "
      clearable
      :items="selectItems.product_families"
      item-text="family.name"
      item-value="family.id"
      v-model="attributesValue.data.product_families.sub_families"
      outlined
      :search-input.sync="searchInput"
      @change="searchInput = ''"
    ></v-autocomplete>
    <div class="text-h6 mb-3 accent--text">
      Olfactive notes
    </div>
    <v-badge
      v-if="differences.product_notes && differences.product_notes.top"
      color="pink"
      icon="mdi-pencil"
      class="d-flex justify-end"
    ></v-badge>
    <v-autocomplete
      :rules="
        rules.product_notes && rules.product_notes.top
          ? rules.product_notes.top
          : []
      "
      return-object
      chips
      deletable-chips
      :disabled="readOnly"
      :loading="loading.product_notes"
      :items="selectItems.product_notes"
      item-text="note.name"
      item-value="note.id"
      v-model="attributesValue.data.product_notes.top"
      multiple
      :label="
        'Head note' +
          (rules.product_notes && rules.product_notes.top ? ' *' : '')
      "
      clearable
      outlined
      :search-input.sync="searchInput"
      @change="searchInput = ''"
    ></v-autocomplete>
    <v-badge
      v-if="differences.product_notes && differences.product_notes.middle"
      color="pink"
      icon="mdi-pencil"
      class="d-flex justify-end"
    ></v-badge>
    <v-autocomplete
      :rules="
        rules.product_notes && rules.product_notes.middle
          ? rules.product_notes.middle
          : []
      "
      return-object
      chips
      deletable-chips
      :disabled="readOnly"
      :loading="loading.product_notes"
      :items="selectItems.product_notes"
      v-model="attributesValue.data.product_notes.middle"
      item-text="note.name"
      item-value="note.id"
      multiple
      :label="
        'Heart note' +
          (rules.product_notes && rules.product_notes.middle ? ' *' : '')
      "
      clearable
      outlined
      :search-input.sync="searchInput"
      @change="searchInput = ''"
    ></v-autocomplete>
    <v-badge
      v-if="differences.product_notes && differences.product_notes.base"
      color="pink"
      icon="mdi-pencil"
      class="d-flex justify-end"
    ></v-badge>
    <v-autocomplete
      :rules="
        rules.product_notes && rules.product_notes.base
          ? rules.product_notes.base
          : []
      "
      return-object
      chips
      deletable-chips
      :disabled="readOnly"
      :loading="loading.product_notes"
      :items="selectItems.product_notes"
      item-text="note.name"
      item-value="note.id"
      multiple
      v-model="attributesValue.data.product_notes.base"
      :label="
        'Body note' +
          (rules.product_notes && rules.product_notes.base ? ' *' : '')
      "
      clearable
      outlined
      :search-input.sync="searchInput"
      @change="searchInput = ''"
    ></v-autocomplete>

    <!-- Start Ingredients -->
    <div class="text-h6 mb-3 accent--text">
      Main notes <span v-if="rules.product_ingredients"> *</span>
    </div>
    <v-badge
      v-if="differences.product_ingredients"
      color="pink"
      icon="mdi-pencil"
      class="d-flex justify-end"
    ></v-badge>
    <v-select
      :rules="rules.product_ingredients ? rules.product_ingredients : []"
      v-if="isForm"
      :disabled="readOnly"
      clearable
      multiple
      placeholder="Choose main notes"
      dense
      v-model="attributesValue.data.product_ingredients"
      :items="getIngredients"
      item-text="note.name"
      item-value="note.id"
      outlined
      @change="IngredientsLimiter"
    ></v-select>
    <!-- End Ingredients -->

    <hr class="mb-5 mt-2 border-none border-slate-800 border-b" />

    <!-- Start Perfumers Houses -->
    <div class="text-h6 mb-3 accent--text">
      Fragrance house <span v-if="rules.product_perfume_houses"> *</span>
    </div>
    <v-badge
      v-if="differences.product_perfume_houses"
      color="pink"
      icon="mdi-pencil"
      class="d-flex justify-end"
    ></v-badge>
    <v-autocomplete
      :rules="rules.product_perfume_houses ? rules.product_perfume_houses : []"
      v-if="isForm"
      :disabled="readOnly"
      clearable
      placeholder="Choose a fragrance house"
      dense
      v-model="attributesValue.data.product_perfumer_house"
      :items="selectItems.product_perfume_houses"
      item-text="label"
      item-value="id"
      outlined
    ></v-autocomplete>
    <!-- End Perfumers Houses -->

    <!-- Start Perfumers -->
    <div class="text-h6 mb-3 accent--text">
      Perfumer <span v-if="rules.product_perfumers"> *</span>
    </div>
    <v-badge
      v-if="differences.product_perfumers"
      color="pink"
      icon="mdi-pencil"
      class="d-flex justify-end"
    ></v-badge>
    <v-autocomplete
      :rules="rules.product_perfumers ? rules.product_perfumers : []"
      v-if="isForm"
      :disabled="readOnly"
      clearable
      placeholder="Choose a perfumer"
      dense
      v-model="attributesValue.data.product_perfumers"
      :items="selectItems.product_perfumers"
      item-text="label"
      item-value="id"
      outlined
    ></v-autocomplete>
    <!-- End Perfumers -->

    <!-- Start Distribution -->
    <div class="text-h6 mb-3 accent--text">
      Market segmentation <span v-if="rules.product_distribution"> *</span>
    </div>
    <v-badge
      v-if="differences.product_distribution"
      color="pink"
      icon="mdi-pencil"
      class="d-flex justify-end"
    ></v-badge>
    <v-autocomplete
      :rules="rules.product_distribution ? rules.product_distribution : []"
      v-if="isForm"
      :disabled="readOnly"
      clearable
      placeholder="Choose a distribution"
      dense
      v-model="attributesValue.data.product_distribution"
      :items="selectItems.product_distribution"
      item-text="label"
      item-value="id"
      outlined
    ></v-autocomplete>
    <!--  End Distribution -->

    <hr class="mb-5 mt-2 border-none border-slate-800 border-b" />

    <!--  Start Product Tags -->
    <div class="text-h6 mb-3 accent--text">
      Tags
    </div>
    <v-autocomplete
      return-object
      chips
      deletable-chips
      :disabled="readOnly"
      :loading="loading.product_tags"
      :items="selectItems.product_tags"
      item-text="label"
      item-value="id"
      multiple
      v-model="attributesValue.data.product_tags"
      :label="'Tags'"
      clearable
      outlined
      :search-input.sync="searchInput"
      @change="searchInput = ''"
    ></v-autocomplete>
    <!--  End Product Tags -->

    <!-- Start Olfactive-Descriptors -->
    <div class="text-h6 mb-3 accent--text">
      Other Olfactory descriptors
    </div>
    <v-autocomplete
      return-object
      chips
      deletable-chips
      :disabled="readOnly"
      :loading="loading.product_other_olfa_desc"
      :items="selectItems.product_other_olfa_desc"
      item-text="label"
      item-value="id"
      multiple
      v-model="attributesValue.data.product_other_olfa_desc"
      :label="'Olfactory descriptors'"
      clearable
      outlined
      :search-input.sync="searchInput"
      @change="searchInput = ''"
    ></v-autocomplete>
  </div>
</template>

<script>
import { GENDERS, PRODUCT_CATEGORIES, PRODUCT_TYPES } from "@/data"
// import { PRODUCT_PERFUMERS, PRODUCT_PERFUMER_HOUSES, PRODUCT_DISTRIBUTIONS, PRODUCT_INGREDIENTS, PRODUCT_TAGS } from "@/data"
import ExtraFieldsService from "@/services/perfumist/ExtraFieldsService"
import NoteService from "@/services/perfumist/NoteService"
import FamilyService from "@/services/perfumist/FamilyService"
export default {
  props: {
    readOnly: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: null
    },
    isForm: {
      type: Boolean,
      default: true
    },
    rules: {
      type: Object,
      default: () => ({})
    },
    differences: {
      type: Object,
      default: () => ({})
    }
  },

  created() {
    this.attributesValue = this.lo.cloneDeep(this.value)
    // if (!this.readOnly) {
    this.getProductNotes()
    this.getProductFamilies()
    this.getProductDistribution()
    this.getProductPerfumers()
    this.getProductPerfumeHouses()
    this.getProductOtherOlfaDesc()
    this.getProductTags()
    // }
  },
  methods: {
    getProductTags(tablename) {
      this.loading.product_tags = true
      ExtraFieldsService.product_tags(this)
        .then(r => {
          this.selectItems.product_tags = r.results || []
        })
        .finally(() => {
          this.loading.product_tags = false
        })
    },
    getProductOtherOlfaDesc(tablename) {
      this.loading.product_other_olfa_desc = true
      ExtraFieldsService.product_other_olfa_desc(this)
        .then(r => {
          this.selectItems.product_other_olfa_desc = r.results || []
        })
        .finally(() => {
          this.loading.product_other_olfa_desc = false
        })
    },
    getProductPerfumeHouses() {
      this.loading.product_perfume_houses = true
      ExtraFieldsService.product_perfume_houses(this)
        .then(r => {
          this.selectItems.product_perfume_houses = r.results || []
        })
        .finally(() => {
          this.loading.product_perfume_houses = false
        })
    },
    getProductPerfumers() {
      this.loading.product_perfumers = true
      ExtraFieldsService.product_perfumers(this)
        .then(r => {
          this.selectItems.product_perfumers = r.results || []
        })
        .finally(() => {
          this.loading.product_perfumers = false
        })
    },
    getProductDistribution() {
      this.loading.product_distribution = true
      ExtraFieldsService.product_distribution(this)
        .then(r => {
          this.selectItems.product_distribution = r.results || []
        })
        .finally(() => {
          this.loading.product_distribution = false
        })
    },
    getProductNotes() {
      this.loading.product_notes = true
      NoteService.get(this)
        .then(r => {
          this.selectItems.product_notes = r.results || []
        })
        .finally(() => {
          this.loading.product_notes = false
        })
    },
    getProductFamilies() {
      this.loading.product_families = true
      FamilyService.get(this)
        .then(r => {
          this.selectItems.product_families = r.results || []
        })
        .finally(() => {
          this.loading.product_families = false
        })
    },
    IngredientsLimiter(e) {
      if (e.length > 3) {
        alert("You can only select 3 !")
        e.pop()
      }
    },
    clampDate() {
      const { year, month, launched_at } = this.attributesValue.data

      if (
        !year ||
        year < 1000 ||
        year > 4000 ||
        !month ||
        month < 1 ||
        month > 12
      )
        return

      const monthStr = month.toString().padStart(2, "0")
      const dayStr = launched_at.split("-")[2]

      this.attributesValue.data.launched_at = `${year}-${monthStr}-${dayStr}`
    },
    updateYearAndMonthFromDate(selectedDate) {
      const date = new Date(selectedDate)

      this.attributesValue.data.year = date.getFullYear()
      this.attributesValue.data.month = date.getMonth() + 1
    }
  },
  watch: {
    "attributesValue.data.year": "clampDate",
    "attributesValue.data.month": "clampDate",
    attributesValue(newValue, oldValue) {
      if (newValue !== null && !this.readOnly) {
        this.$emit("input", newValue)
      }
    },
    value(newValue, oldValue) {
      this.attributesValue = newValue
    }
  },
  computed: {
    getIngredients() {
      var results = []
      results = [
        ...this.attributesValue.data.product_notes.top,
        ...this.attributesValue.data.product_notes.base,
        ...this.attributesValue.data.product_notes.middle
      ]
      return results
    },
  },
  data() {
    return {
      searchInput: "",
      menu1: false,
      menu2: false,
      loading: {
        product_notes: false,
        product_families: false
      },
      selectItems: {
        product_types: PRODUCT_TYPES,
        product_perfumers: [],
        product_perfume_houses: [],
        product_distribution: [],
        product_ingredients: [],
        // product_tags: PRODUCT_TAGS,
        genders: GENDERS,
        categories: PRODUCT_CATEGORIES,
        product_notes: [],
        product_families: []
      },
      attributesValue: null
    }
  }
}
</script>

<style lang="scss" scoped></style>
